(function () {
  'use strict';

  const isMobile = () => window.innerWidth < 990;

  function setHeaderOffset() {
    const header = document.querySelector('sticky-header, header.header');
    if (header) {
      document.documentElement.style.setProperty('--pdp-top', Math.round(header.getBoundingClientRect().height) + 'px');
    }
  }

  class PdpGallery {
    constructor(sectionId) {
      this.gallery = document.getElementById('pdp-gallery-' + sectionId);
      this.thumbsEl = document.getElementById('pdp-thumbs-' + sectionId);
      this.mThumbsEl = document.getElementById('pdp-mobile-thumbs-' + sectionId);
      if (!this.gallery) return;

      this.items = [...this.gallery.querySelectorAll('.custom-pdp__media')];
      this.dThumbs = [...(this.thumbsEl?.querySelectorAll('.custom-pdp__thumb') || [])];
      this.mThumbs = [...(this.mThumbsEl?.querySelectorAll('.custom-pdp__mobile-thumb') || [])];
      this.current = 0;
      this.modal = new PdpModal(sectionId, this);

      this.dThumbs.forEach((t, i) => t.addEventListener('click', () => this.goTo(i, true)));
      this.mThumbs.forEach((t, i) => t.addEventListener('click', () => this.goTo(i, true)));
      this.items.forEach((item, i) => item.addEventListener('click', () => this.modal.open(i)));
      
      // Touch/swipe para mobile
      this.initTouch();
      
      // Sincronizar thumbnails con scroll del slider
      if (isMobile()) {
        this.gallery.addEventListener('scroll', () => {
          const scrollLeft = this.gallery.scrollLeft;
          const widths = [...this.items].map((_, i) => this.gallery.clientWidth * i);
          const idx = widths.findIndex(w => scrollLeft < w + this.gallery.clientWidth / 2);
          if (idx >= 0 && idx !== this.current) {
            this.current = idx;
            this.items.forEach((el, i) => el.classList.toggle('is-active', i === idx));
            this.dThumbs.forEach((el, i) => el.classList.toggle('is-active', i === idx));
            this.mThumbs.forEach((el, i) => el.classList.toggle('is-active', i === idx));
          }
        }, { passive: true });
      }
    }

    initTouch() {
      if (!isMobile()) return;
      let startX = 0, startY = 0, isDragging = false;
      
      this.gallery.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        isDragging = true;
      }, { passive: true });

      this.gallery.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        const dx = e.touches[0].clientX - startX;
        const dy = e.touches[0].clientY - startY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) {
          // Solo permitir swipe si hay más imágenes en esa dirección
          if (dx > 0 && this.current > 0) {
            this.prev();
          } else if (dx < 0 && this.current < this.items.length - 1) {
            this.next();
          }
          isDragging = false;
        }
      }, { passive: true });

      this.gallery.addEventListener('touchend', () => { isDragging = false; }, { passive: true });
    }

    goTo(index, scroll = false) {
      this.current = index;
      this.items.forEach((el, i) => el.classList.toggle('is-active', i === index));
      this.dThumbs.forEach((el, i) => el.classList.toggle('is-active', i === index));
      this.mThumbs.forEach((el, i) => el.classList.toggle('is-active', i === index));
      if (scroll) {
        const target = this.items[index];
        if (target) {
          this.gallery.scrollTo(isMobile()
            ? { left: target.offsetLeft, behavior: 'smooth' }
            : { top: target.offsetTop, behavior: 'smooth' });
        }
      }
    }
    
    next() {
      const nextIdx = (this.current + 1) % this.items.length;
      this.goTo(nextIdx, false);
    }
    
    prev() {
      const prevIdx = (this.current - 1 + this.items.length) % this.items.length;
      this.goTo(prevIdx, false);
    }
  }

  class PdpModal {
    constructor(sectionId, gallery) {
      this.gallery = gallery;
      this.modal = document.getElementById('pdp-modal-' + sectionId);
      if (!this.modal) return;

      this.stage = document.getElementById('pdp-modal-stage-' + sectionId);
      this.imgs = [...(this.stage?.querySelectorAll('.custom-pdp__modal-img') || [])];
      this.closeBtn = document.getElementById('pdp-modal-close-' + sectionId);
      this.zoomBtn = document.getElementById('pdp-modal-zoom-' + sectionId);
      this.thumbs = [...this.modal.querySelectorAll('.custom-pdp__modal-thumb')];
      this.current = 0;
      this.zoomed = false;

      this.warmFirstImage();
      this.closeBtn?.addEventListener('click', () => this.close());
      this.zoomBtn?.addEventListener('click', () => this.toggleZoom());
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.show(i)));
      this.modal.addEventListener('click', (e) => { if (e.target === this.modal) this.close(); });

      // Sincronizar thumbnail activo al hacer scroll
      this.stage?.addEventListener('scroll', () => {
        const idx = Math.round(this.stage.scrollTop / this.stage.clientHeight);
        if (idx !== this.current && idx >= 0 && idx < this.imgs.length) {
          this.current = idx;
          this.thumbs.forEach((th, i) => th.classList.toggle('is-active', i === idx));
          this.gallery?.goTo(idx);
        }
      }, { passive: true });

      document.addEventListener('keydown', (e) => {
        if (!this.modal || this.modal.hidden) return;
        ({
          Escape: () => this.close(), ArrowDown: () => this.next(), ArrowRight: () => this.next(),
          ArrowUp: () => this.prev(), ArrowLeft: () => this.prev()
        })[e.key]?.();
      });
    }

    hydrateImage(img, priority) {
      if (!img || !img.dataset.src) return;
      if (priority) {
        img.loading = 'eager';
        img.fetchPriority = priority;
      }
      img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      delete img.dataset.src;
      delete img.dataset.srcset;
    }

    // The image the visitor asked for loads first and eagerly; the rest keep
    // loading="lazy" so only the ones near the viewport are fetched.
    loadImages(priorityIndex) {
      this.hydrateImage(this.imgs[priorityIndex], 'high');
      this.imgs.forEach((img, i) => { if (i !== priorityIndex) this.hydrateImage(img); });
    }

    // Warm only the first (most likely to be zoomed) image once the page has
    // loaded and the browser is idle, so the first zoom feels instant without
    // competing with the gallery for the initial load.
    warmFirstImage() {
      const warm = () => {
        const idle = window.requestIdleCallback || ((cb) => setTimeout(cb, 1500));
        idle(() => this.hydrateImage(this.imgs[0], 'low'), { timeout: 4000 });
      };
      if (document.readyState === 'complete') warm();
      else window.addEventListener('load', warm, { once: true });
    }

    open(index) {
      if (!this.modal) return;
      this.loadImages(Math.max(0, Math.min(index || 0, this.imgs.length - 1)));
      this.modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => requestAnimationFrame(() => {
        this.modal.classList.add('is-open');
        this.show(index);
      }));
    }

    close() {
      if (!this.modal) return;
      this.modal.classList.remove('is-open');
      document.body.style.overflow = '';
      if (this.zoomed) this.toggleZoom();
      const hide = () => this.modal.setAttribute('hidden', '');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        hide();
      } else {
        this.modal.addEventListener('transitionend', hide, { once: true });
      }
    }

    show(index) {
      if (index < 0 || index >= this.imgs.length) return;
      this.current = index;
      this.thumbs.forEach((th, i) => th.classList.toggle('is-active', i === index));
      this.gallery?.goTo(index);
      this.stage?.scrollTo({ top: index * this.stage.clientHeight, behavior: 'smooth' });
    }

    next() { this.show(Math.min(this.current + 1, this.imgs.length - 1)); }
    prev() { this.show(Math.max(this.current - 1, 0)); }

    toggleZoom() {
      this.zoomed = !this.zoomed;
      this.imgs.forEach(img => img.classList.toggle('is-zoomed', this.zoomed));
      if (this.zoomBtn) {
        this.zoomBtn.dataset.zoomed = this.zoomed;
        this.zoomBtn.setAttribute('aria-label', this.zoomed ? 'Zoom out' : 'Zoom');
      }
    }
  }

  class PdpDrawer {
    constructor(sectionId) {
      this.el = document.getElementById('pdp-drawer-' + sectionId);
      if (!this.el) return;
      this.panel = this.el.querySelector('.custom-pdp__drawer-panel');
      this.overlay = this.el.querySelector('.custom-pdp__drawer-overlay');
      this.titleEl = document.getElementById('pdp-drawer-title-' + sectionId);
      this.bodyEl = document.getElementById('pdp-drawer-body-' + sectionId);
      this.current = null;

      this.el.querySelector('.custom-pdp__drawer-close')?.addEventListener('click', () => this.close());
      this.overlay?.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.el.hidden) this.close();
      });
    }

    open(title, html, trigger) {
      if (!this.el) return;
      if (this.current) this.current.setAttribute('data-drawer-open', 'false');
      this.current = trigger || null;
      if (this.current) this.current.setAttribute('data-drawer-open', 'true');
      if (this.titleEl) this.titleEl.textContent = title;
      if (this.bodyEl) this.bodyEl.innerHTML = html;
      this.el.hidden = false;
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => this.el.classList.add('is-open'));
    }

    close() {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      document.body.style.overflow = '';
      if (this.current) { this.current.setAttribute('data-drawer-open', 'false'); this.current = null; }
      const hide = () => { this.el.hidden = true; };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        hide();
      } else {
        this.panel?.addEventListener('transitionend', hide, { once: true });
      }
    }
  }

  class PdpAccordions {
    constructor(sectionId) {
      const info = document.getElementById('pdp-tabs-' + sectionId);
      if (!info) return;

      info.querySelectorAll('.custom-pdp__accordion').forEach((acc) => {
        const trigger = acc.querySelector('.custom-pdp__accordion-trigger');
        const body = acc.querySelector('.custom-pdp__accordion-body');
        if (!trigger || !body) return;

        trigger.addEventListener('click', () => {
          const open = acc.dataset.open === 'true';
          acc.dataset.open = (!open).toString();
          trigger.setAttribute('aria-expanded', (!open).toString());
          body.hidden = open;
        });
      });
    }
  }

  class PdpTabs {
    constructor(sectionId) {
      const info = document.getElementById('pdp-tabs-' + sectionId);
      if (!info) return;

      this.accordions = [...info.querySelectorAll('.custom-pdp__accordion')];
      if (!this.accordions.length) return;

      this.current = 0;
      this.navEl = null;
      this.built = false;

      this._init();
      window.addEventListener('resize', () => this._init(), { passive: true });
    }

    _init() {
      if (!this.built) this._build();
      if (this.navEl) this.navEl.style.display = '';
      this._show(this.current);
      this.accordions.forEach((acc) => {
        acc.querySelector('.custom-pdp__accordion-trigger')?.style.setProperty('display', 'none');
      });
    }

    _build() {
      const firstAcc = this.accordions[0];
      if (!firstAcc) return;

      this.navEl = document.createElement('div');
      this.navEl.className = 'custom-pdp__tab-nav';
      this.navEl.setAttribute('role', 'tablist');

      this.accordions.forEach((acc, i) => {
        const btn = document.createElement('button');
        btn.className = 'custom-pdp__tab-btn' + (i === 0 ? ' is-active' : '');
        btn.textContent = acc.dataset.moxieHeading || 'Tab ' + (i + 1);
        btn.type = 'button';
        btn.setAttribute('role', 'tab');
        btn.addEventListener('click', () => this._show(i));
        this.navEl.appendChild(btn);
      });

      firstAcc.parentNode.insertBefore(this.navEl, firstAcc);
      this.built = true;
    }

    _show(index) {
      this.current = index;
      this.navEl?.querySelectorAll('.custom-pdp__tab-btn').forEach((b, i) => b.classList.toggle('is-active', i === index));
      this.accordions.forEach((acc, i) => {
        const body = acc.querySelector('.custom-pdp__accordion-body');
        if (body) body.hidden = (i !== index);
      });
    }
  }

  class PdpStlScroll {
    constructor(sectionId) {
      const tabsEl = document.getElementById('pdp-tabs-' + sectionId);
      if (!tabsEl) return;
      this.track = tabsEl.querySelector('.custom-pdp__stl-track');
      this.bar = tabsEl.querySelector('.custom-pdp__stl-bar');
      this.thumb = tabsEl.querySelector('.custom-pdp__stl-bar-thumb');
      if (!this.track || !this.bar || !this.thumb) return;

      requestAnimationFrame(() => this._update());
      this.track.addEventListener('scroll', () => this._update(), { passive: true });
      window.addEventListener('resize', () => this._update(), { passive: true });
      this._initDrag();
    }

    _update() {
      if (isMobile()) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const ratio = clientWidth / scrollWidth;
      const thumbW = Math.max(40, this.bar.clientWidth * ratio);
      const maxScroll = scrollWidth - clientWidth;
      const maxLeft = this.bar.clientWidth - thumbW;
      this.thumb.style.width = thumbW + 'px';
      this.thumb.style.left = (maxScroll > 0 ? (scrollLeft / maxScroll) * maxLeft : 0) + 'px';
    }

    _initDrag() {
      let startX, startScroll;
      this.thumb.addEventListener('mousedown', (e) => {
        startX = e.clientX;
        startScroll = this.track.scrollLeft;
        const onMove = (e) => {
          const { scrollWidth, clientWidth } = this.track;
          const maxScroll = scrollWidth - clientWidth;
          const maxLeft = this.bar.clientWidth - this.thumb.offsetWidth;
          if (maxLeft > 0) this.track.scrollLeft = startScroll + ((e.clientX - startX) / maxLeft) * maxScroll;
        };
        const onUp = () => { document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp); };
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onUp);
        e.preventDefault();
      });
    }
  }

  class PdpStickyAtc {
    constructor(sectionId) {
      this.bar = document.getElementById('pdp-sticky-atc-' + sectionId);
      this.section = document.getElementById('custom-pdp-' + sectionId);
      const trigger = this.section?.querySelector('.custom-pdp__buy-wrap');
      if (!this.bar || !trigger) return;

      const observer = new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting;
        this.bar.classList.toggle('is-visible', show);
        this.section.classList.toggle('has-sticky', show);
      }, { threshold: 0 });

      observer.observe(trigger);
    }
  }

  /* ── Sticky Dropdown (size picker) ────────────────────────── */
  function initStickyDropdown(sectionId) {
    const pdp = document.getElementById('custom-pdp-' + sectionId);
    if (!pdp) return;

    const dropdown = document.getElementById('pdp-sticky-dropdown-' + sectionId);
    const dropdownInner = dropdown?.querySelector('.custom-pdp__sticky-dropdown-inner');
    const stickyForm = pdp.querySelector('form.custom-pdp__sticky-form');
    const stickyBtn = stickyForm?.querySelector('.custom-pdp__btn-atc');
    if (!dropdown || !dropdownInner || !stickyForm || !stickyBtn) return;

    const variantSelects = pdp.querySelector('variant-selects');
    if (!variantSelects) return;

    // Abort previous listeners + timers on re-init (theme editor / section reload)
    if (dropdown._stickyAbort) {
      dropdown._stickyAbort.abort();
      clearTimeout(dropdown._resetTimer);
      clearTimeout(dropdown._closeTimer);
    }
    const controller = new AbortController();
    const { signal } = controller;
    dropdown._stickyAbort = controller;

    let isAdding = false;
    const strings = window.variantStrings || {};
    const liveRegion = stickyForm.querySelector('[data-sticky-atc-live]');

    function announce(text) {
      if (liveRegion) liveRegion.textContent = text || '';
    }

    const optionNames = getVariantOptionNames(variantSelects);
    const variants = getVariantList(variantSelects);
    if (!variants.length || !optionNames.length) return;

    const sizeIdx = optionNames.findIndex((n) => /size|talla/i.test(n));
    const colorIdx = optionNames.findIndex((n) => /color|colour/i.test(n));
    if (sizeIdx === -1) return;
    const sizeName = optionNames[sizeIdx]; // e.g. "Size" — matches radio name="options[Size]"

    function getSizes() {
      const selected = getSelectedOptionValuesByName(variantSelects);
      const color = colorIdx !== -1 ? selected[optionNames[colorIdx]] : null;
      const sizeMap = new Map();
      variants.forEach((v) => {
        if (color && v.options[colorIdx] !== color) return;
        const size = v.options[sizeIdx];
        if (size && !sizeMap.has(size)) sizeMap.set(size, { size, available: v.available, id: v.id });
      });
      return Array.from(sizeMap.values());
    }

    function renderDropdown() {
      const currentId = Number(stickyForm.querySelector('input[name="id"]')?.value || 0);
      dropdownInner.innerHTML = '';
      getSizes().forEach(({ size, available, id }) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'custom-pdp__sticky-dropdown-item'
          + (available ? '' : ' is-sold-out')
          + (id === currentId ? ' is-selected' : '');
        btn.dataset.variantId = id;
        btn.dataset.available = String(available);
        btn.setAttribute('aria-pressed', id === currentId ? 'true' : 'false');

        const sizeSpan = document.createElement('span');
        sizeSpan.className = 'custom-pdp__dropdown-size';
        sizeSpan.textContent = size;
        btn.appendChild(sizeSpan);

        if (!available) {
          const notifySpan = document.createElement('span');
          notifySpan.className = 'custom-pdp__dropdown-notify';
          notifySpan.textContent = strings.notifyMe || 'Notify me';
          btn.appendChild(notifySpan);
        }

        dropdownInner.appendChild(btn);
      });
    }

    /** Click the real radio in the main PDP so variant-selects + syncVariantSelectionForms update. */
    function selectMainPDPVariant(sizeValue) {
      const radio = variantSelects.querySelector(
        `input[type="radio"][name="options[${sizeName}]"][value="${CSS.escape(sizeValue)}"]`
      );
      if (radio && !radio.checked) radio.click();
    }

    function addToCart(variantId) {
      if (isAdding) return;
      isAdding = true;

      const span = stickyBtn.querySelector('span');
      const addingText = strings.addingToCart || 'Adding...';
      if (span) span.textContent = addingText;
      announce(addingText);
      stickyBtn.setAttribute('aria-disabled', 'true');
      hideErrorMessage();

      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');
      const cartItems = document.querySelector('cart-items');
      const formData = new FormData(stickyForm);
      formData.set('id', variantId);

      // Sections: .id for cartDrawer/cartNotification, .section for cartItems (canonical pattern)
      const sections = [
        ...(cartDrawer?.getSectionsToRender?.() || []).map((s) => s.id),
        ...(cartNotification?.getSectionsToRender?.() || []).map((s) => s.id),
        ...(cartItems?.getSectionsToRender?.() || []).map((s) => s.section),
      ];
      if (sections.length) {
        formData.set('sections', [...new Set(sections)]);
        formData.set('sections_url', window.location.pathname);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then((r) => r.json())
        .then((res) => {
          if (res.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: String(variantId),
              errors: res.errors || res.description,
              message: res.message,
            });
            const errText = res.description || strings.couldNotAddToCart || 'Could not add to cart';
            showErrorMessage(errText);
            announce(errText);
            resetButton();
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: String(variantId),
            cartData: res,
          });

          cartDrawer?.renderContents(res);
          cartNotification?.renderContents(res);
          cartItems?.renderContents(res);

          const addedText = strings.addedToCart || 'Added!';
          if (span) span.textContent = addedText;
          announce(addedText);
        })
        .catch(() => resetButton())
        .finally(() => {
          isAdding = false;
          if (cartDrawer?.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
          if (cartNotification?.classList.contains('is-empty')) cartNotification.classList.remove('is-empty');
          clearTimeout(dropdown._resetTimer);
          dropdown._resetTimer = setTimeout(() => resetButton(), 1500);
        });
    }

    function showErrorMessage(msg) {
      const wrapper = stickyForm.querySelector('.product-form__error-message-wrapper');
      const el = wrapper?.querySelector('.product-form__error-message');
      if (!wrapper || !el) return;
      el.textContent = msg;
      wrapper.hidden = false;
      requestAnimationFrame(() => wrapper.classList.add('is-visible'));
    }

    function hideErrorMessage() {
      const wrapper = stickyForm.querySelector('.product-form__error-message-wrapper');
      if (wrapper) {
        wrapper.hidden = true;
        wrapper.classList.remove('is-visible');
      }
    }

    function resetButton() {
      const span = stickyBtn.querySelector('span');
      if (span) span.textContent = strings.addToCart || 'Add to cart';
      stickyBtn.removeAttribute('aria-disabled');
    }

    function openDropdown() {
      renderDropdown();
      dropdown.classList.add('is-open');
    }

    function closeDropdown() {
      dropdown.classList.remove('is-open');
    }

    stickyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      if (dropdown.classList.contains('is-open')) {
        closeDropdown();
        return;
      }

      // Mobile: if a variant is already selected, add to cart directly
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      if (isMobile) {
        const selectedId = stickyForm.querySelector('input[name="id"]')?.value;
        if (selectedId) {
          addToCart(Number(selectedId));
          return;
        }
      }

      openDropdown();
    }, { signal });

    dropdownInner.addEventListener('click', (e) => {
      const item = e.target.closest('.custom-pdp__sticky-dropdown-item');
      if (!item) return;
      const sizeText = item.querySelector('.custom-pdp__dropdown-size')?.textContent;
      dropdownInner.querySelectorAll('.is-selected').forEach((el) => {
        el.classList.remove('is-selected');
        el.setAttribute('aria-pressed', 'false');
      });
      item.classList.add('is-selected');
      item.setAttribute('aria-pressed', 'true');
      if (sizeText) selectMainPDPVariant(sizeText);
      clearTimeout(dropdown._closeTimer);
      dropdown._closeTimer = setTimeout(closeDropdown, 200);
      if (item.dataset.available !== 'true') return;
      addToCart(Number(item.dataset.variantId));
    }, { signal });

    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target) && !stickyBtn.contains(e.target)) closeDropdown();
    }, { signal });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !dropdown.classList.contains('is-open')) return;
      closeDropdown();
      stickyBtn.focus();
    }, { signal });
  }

  // Centra el collage verticalmente en el viewport mientras la columna izquierda scrollea.
  // Usa position: sticky (CSS) + top dinámico (JS) para que el collage quede siempre
  // en la mitad de la pantalla hasta que se acabe el contenido de la otra columna.
function initStoryParallax() {
    if (window.innerWidth < 990) return;

    const collage = document.querySelector('.custom-pdp-story__collage');
    if (!collage) return;

    function update() {
      const collageH = collage.offsetHeight;
      const vh = window.innerHeight;
      collage.style.top = Math.max(0, Math.round((vh - collageH) / 2)) + 'px';
    }

    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function updateStockMessage(customPdp) {
    if (window.VariantLowStock?.update) {
      window.VariantLowStock.update(customPdp || document.querySelector('.custom-pdp') || document);
    }
  }

  function initVariantPickerLabels() {
    document.querySelectorAll('variant-selects').forEach((el) => {
      el.addEventListener('change', (e) => {
        const input = e.target;
        if (input.type !== 'radio') return;
        const group = input.closest('.custom-pdp__vp-group');
        if (!group) return;
        const display = group.querySelector('[data-selected-value]');
        if (display) display.textContent = input.value;

        const form = document.getElementById(input.getAttribute('form'));
        if (form) hideVariantSelectionError(form);
        const customPdp = el.closest('.custom-pdp');
        if (customPdp) {
          syncVariantSelectionForms(customPdp);
          updateStockMessage(customPdp);
        }
      });
    });
  }

  function setVariantSelectionErrorVisibility(wrapper, isVisible) {
    if (!wrapper) return;

    if (wrapper.dataset.hideTimeoutId) {
      window.clearTimeout(Number(wrapper.dataset.hideTimeoutId));
      delete wrapper.dataset.hideTimeoutId;
    }

    if (isVisible) {
      wrapper.hidden = false;
      window.requestAnimationFrame(() => {
        wrapper.classList.add('is-visible');
      });
      return;
    }

    wrapper.classList.remove('is-visible');
    const hideTimeoutId = window.setTimeout(() => {
      wrapper.hidden = true;
      delete wrapper.dataset.hideTimeoutId;
    }, 220);
    wrapper.dataset.hideTimeoutId = String(hideTimeoutId);
  }

  function showVariantSelectionError(form, message) {
    const wrapper = form.querySelector('.custom-pdp__form-error');
    const messageNode = wrapper?.querySelector('.product-form__error-message');

    if (!wrapper || !messageNode) {
      alert(message);
      return;
    }

    messageNode.textContent = message;
    setVariantSelectionErrorVisibility(wrapper, true);
  }

  function hideVariantSelectionError(form) {
    const wrapper = form.querySelector('.custom-pdp__form-error');
    if (!wrapper) return;
    setVariantSelectionErrorVisibility(wrapper, false);
  }

  function getVariantSelectionForms(scope) {
    return Array.from(scope.querySelectorAll('form[data-require-variant-selection="true"]'));
  }

  function getVariantSelectsForForm(form) {
    const customPdp = form.closest('.custom-pdp');
    return customPdp?.querySelector('variant-selects') || null;
  }

  function hasAllRequiredVariantSelections(form) {
    const variantSelects = getVariantSelectsForForm(form);
    if (!variantSelects) return true;

    const requiredVisibleOptions = Number(variantSelects.dataset.requiredVisibleOptions || 0);
    if (requiredVisibleOptions === 0) return true;

    const selectedVisibleOptions = variantSelects.querySelectorAll('fieldset input:checked').length;
    return selectedVisibleOptions >= requiredVisibleOptions;
  }

  function getVariantOptionNames(variantSelects) {
    const optionNamesNode = variantSelects?.querySelector('[data-product-option-names]');
    if (!optionNamesNode) return [];

    try {
      return JSON.parse(optionNamesNode.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function getVariantList(variantSelects) {
    const variantsNode = variantSelects?.querySelector('[data-product-variants]');
    if (!variantsNode) return [];

    try {
      return JSON.parse(variantsNode.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function getSelectedOptionValuesByName(variantSelects) {
    const selectedOptions = {};
    if (!variantSelects) return selectedOptions;

    variantSelects.querySelectorAll('input[type="radio"][name^="options["]:checked').forEach((input) => {
      const optionName = input.name.replace(/^options\[/, '').replace(/\]$/, '');
      selectedOptions[optionName] = input.value;
    });

    variantSelects.querySelectorAll('select[name^="options["]').forEach((select) => {
      const optionName = select.name.replace(/^options\[/, '').replace(/\]$/, '');
      selectedOptions[optionName] = select.value;
    });

    return selectedOptions;
  }

  function getResolvedVariantForForm(form) {
    const variantSelects = getVariantSelectsForForm(form);
    if (!variantSelects || !hasAllRequiredVariantSelections(form)) return null;

    const optionNames = getVariantOptionNames(variantSelects);
    const variants = getVariantList(variantSelects);
    const selectedOptions = getSelectedOptionValuesByName(variantSelects);

    if (!optionNames.length || !variants.length) return null;
    if (optionNames.some((optionName) => !selectedOptions[optionName])) return null;

    return variants.find((variant) =>
      Array.isArray(variant.options) &&
      variant.options.every((optionValue, index) => optionValue === selectedOptions[optionNames[index]])
    ) || null;
  }

  function syncVariantSelectionForms(customPdp) {
    const forms = getVariantSelectionForms(customPdp);
    if (!forms.length) return;

    const resolvedVariant = getResolvedVariantForForm(forms[0]);
    const variantId = resolvedVariant?.id ? String(resolvedVariant.id) : '';

    forms.forEach((form) => {
      const variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput) return;

      if (!hasAllRequiredVariantSelections(form)) {
        variantIdInput.value = '';
        variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      variantIdInput.value = variantId;
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function getFirstMissingVariantOptionName(form) {
    const variantSelects = getVariantSelectsForForm(form);
    if (!variantSelects) return '';

    const requiredVisibleOptions = Number(variantSelects.dataset.requiredVisibleOptions || 0);
    if (requiredVisibleOptions === 0) return '';

    const groups = Array.from(
      variantSelects.querySelectorAll('fieldset.custom-pdp__vp-group')
    ).filter((group) => {
      const name = group.querySelector('.custom-pdp__vp-label-name')?.textContent?.toLowerCase() || '';
      return !name.includes('color') && !name.includes('colour');
    });

    let checkedCount = 0;

    for (const group of groups) {
      const checked = group.querySelector('input:checked');

      if (checked) {
        checkedCount++;
        continue;
      }

      if (checkedCount < requiredVisibleOptions) {
        const optionName = group.querySelector('.custom-pdp__vp-label-name')?.textContent || '';
        return optionName.replace(/:\s*$/, '').trim();
      }
    }

    return '';
  }

  function getVariantSelectionErrorMessage(form) {
    const missingOptionName = getFirstMissingVariantOptionName(form);
    if (missingOptionName) {
      return `Please select ${missingOptionName}`;
    }

    return window.variantStrings.selectSize || 'Please select a size';
  }

  function setVariantSyncState(form, isSyncing) {
    if (!form) return;

    if (isSyncing) {
      form.dataset.variantSyncing = 'true';
      return;
    }

    delete form.dataset.variantSyncing;
    delete form.dataset.variantRetryPending;
  }

  function initVariantSelectionGuard() {
    if (document.body.dataset.pdpVariantSelectionGuard === 'true') return;
    document.body.dataset.pdpVariantSelectionGuard = 'true';

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.type !== 'radio') return;

      const variantSelects = target.closest('variant-selects');
      if (!variantSelects) return;

      const customPdp = variantSelects.closest('.custom-pdp');
      if (!customPdp) return;

      syncVariantSelectionForms(customPdp);
      getVariantSelectionForms(customPdp).forEach((form) => {
        setVariantSyncState(form, true);
        hideVariantSelectionError(form);
      });
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.name !== 'id') return;

      const form = target.form;
      if (!form || form.dataset.requireVariantSelection !== 'true') return;

      if (target.value && hasAllRequiredVariantSelections(form)) {
        setVariantSyncState(form, false);
        hideVariantSelectionError(form);
      } else {
        delete form.dataset.variantRetryPending;
      }
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.dataset.requireVariantSelection !== 'true') return;

      if (form.dataset.skipVariantGuard === 'true') {
        delete form.dataset.skipVariantGuard;
        return;
      }

      const customPdp = form.closest('.custom-pdp');
      if (customPdp) syncVariantSelectionForms(customPdp);

      const variantIdInput = form.querySelector('input[name="id"]');
      if (!variantIdInput) return;
      if (variantIdInput.value && hasAllRequiredVariantSelections(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      showVariantSelectionError(form, getVariantSelectionErrorMessage(form));
    }, true);
  }

  // Keep submit buttons in sync with actual variant availability.
  // Targets both main and sticky ATC buttons. Sticky button is never
  // disabled — always clickable.
  function initSubmitButtonSync() {
    document.querySelectorAll('.custom-pdp[data-section]').forEach((pdp) => {
      const variantSelects = pdp.querySelector('variant-selects');
      if (!variantSelects) return;

      const variants = getVariantList(variantSelects);
      if (!variants.length) return;
      const variantMap = {};
      variants.forEach((v) => { variantMap[v.id] = v; });

      function fixButton() {
        const hiddenInput = pdp.querySelector('input[name="id"]');
        if (!hiddenInput) return;
        const v = variantMap[parseInt(hiddenInput.value, 10)];
        if (!v) return;
        pdp.querySelectorAll('.custom-pdp__btn-atc').forEach((submitBtn) => {
          const isSticky = submitBtn.closest('form')?.classList.contains('custom-pdp__sticky-form');
          const span = submitBtn.querySelector('span');
          if (v.available) {
            submitBtn.removeAttribute('disabled');
            if (span) span.textContent = window.variantStrings?.addToCart || 'Add to cart';
          } else {
            if (!isSticky) submitBtn.setAttribute('disabled', '');
            if (span) span.textContent = window.variantStrings?.soldOut || 'Sold out';
          }
        });
      }

      // Sync after Dawn's section fetch (pub/sub fires after DOM update)
      subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
        if (data.data.sectionId === pdp.dataset.section) fixButton();
      });

      // Sync on hidden input change (covers Dawn's updateVariantInputs)
      pdp.addEventListener('change', (e) => {
        if (e.target.name === 'id') fixButton();
      });

      // Fix initial state on page load
      fixButton();
      // Sticky button is never disabled — remove Liquid's initial disabled
      const stickyBtn = pdp.querySelector('form.custom-pdp__sticky-form .custom-pdp__btn-atc');
      if (stickyBtn) stickyBtn.removeAttribute('disabled');
    });
  }

  function init() {
    setHeaderOffset();
    window.addEventListener('resize', setHeaderOffset, { passive: true });

    document.querySelectorAll('.custom-pdp[data-section]').forEach((el) => {
      const id = el.dataset.section;
      new PdpGallery(id);
      new PdpAccordions(id);
      new PdpTabs(id);
      new PdpStlScroll(id);
      new PdpStickyAtc(id);
      initStickyDropdown(id);
      syncVariantSelectionForms(el);
      updateStockMessage(el);
    });
    initVariantPickerLabels();
    initVariantSelectionGuard();
    initSubmitButtonSync();
    initStoryParallax();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
